import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { CSSRulePlugin } from "gsap/CSSRulePlugin.js";
gsap.registerPlugin(ScrollTrigger, CSSRulePlugin);

if (document.querySelector('.bg-img-fullwidth')) {

// bg-imgfullwidth with pinned content
ScrollTrigger.matchMedia({
  "(min-width: 800px)": function() {

    let pinnedImgContainer = '.bg-img-fullwidth'
    let pinnedImg = '.pinned-img'


    const imgBg = gsap.timeline({
      scrollTrigger: {
        trigger: pinnedImgContainer,
        scrub: true,
        // pin: true,
        start: "-1000px",
        end: "+=100%",
      }
    });

    imgBg
      .from(pinnedImgContainer, { height: 0} )
      .from(pinnedImg, .25, {opacity: 0}, '-=.25' );


    const imgBgpinnedContent = ScrollTrigger.create({
      trigger: pinnedImgContainer,
      start: "top top",
      end: "+=20%",
      pin: pinnedImg,
    });
  

}});

};











